import { Permission } from 'shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { AsphaltMixDesign } from '../../AsphaltMixDesignsContext/types'
import { BodyValues } from './components/Body/types'
import Body from './components/Body'
import { useAsphaltMixDesignsContext } from '../../AsphaltMixDesignsContext'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { toMoment } from 'utils/toMoment'
import { Percentage } from '../../components/AdditionalInfo/types'

export function useEdit(): EditRowActionOptions<AsphaltMixDesign, BodyValues> {
  const { refetch, edit, metadata } = useAsphaltMixDesignsContext()
  const { toMutateCustomFieldsInput, toCustomFieldEditorValue } =
    useProjectCustomFieldsContext()
  return {
    permission: Permission.EditAsphaltMixDesign,
    hidden: ({ active }) => !active,
    modal: {
      type: 'simple',
      recordName: 'mixDesignNumber',
      body: <Body />,
      initialValues: ({
        customFields,
        percentages,
        bulkSpecGravAgg,
        designBinderContent,
        grade,
        nominalSize,
        supplier,
        mixDesignNumber,
        theoMaxSpecGrav,
        expirationDate,
        asphaltMaterialSource,
        maxAggregateSize,
        vma,
      }) => ({
        customFields: toCustomFieldEditorValue(customFields),
        designBinderContent,
        grade,
        mixDesignNumber,
        nominalSize,
        supplier,
        theoMaxSpecGrav,
        vma,
        bulkSpecGravAgg,
        percentages: metadata.targets.reduce(
          (values, { id: targetId, required, name }) => {
            const { percentage } =
              percentages.find(({ target }) => target.id === targetId) ?? {}
            if (typeof percentage === 'number')
              values.push({ name, targetId, percentage })
            else if (required) values.push({ name, targetId, percentage: null })
            return values
          },
          Array<Percentage>()
        ),
        expirationDate: toMoment(expirationDate),
        maxAggregateSize,
        materialSource: asphaltMaterialSource
          ? {
              label:
                asphaltMaterialSource.source ?? asphaltMaterialSource.globalId,
              value: asphaltMaterialSource.globalId,
              deleted: asphaltMaterialSource.isDeleted,
            }
          : null,
      }),
      onOk: async (
        { globalId },
        { customFields, percentages, expirationDate, materialSource, ...values }
      ) => {
        await edit({
          variables: {
            input: {
              ...values,
              materialSourceId: materialSource?.value as string,
              // Required field so using bang
              expirationDate: expirationDate!.toISOString(),
              globalId,
              customFields: toMutateCustomFieldsInput(customFields),
              percentages: percentages?.map(({ percentage, targetId }) => ({
                // Required field so using bang
                percentage: percentage!,
                targetId,
              })),
            },
          },
        })
        refetch()
      },
    },
  }
}
